import script from "./SettingLogicPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingLogicPage.vue?vue&type=script&setup=true&lang=ts"

import "./SettingLogicPage.vue?vue&type=style&index=0&id=514f3e4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-514f3e4c"]])

export default __exports__